import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubLandingRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-landing',
	path: '/jira/servicedesk/projects/:projectKey/knowledge',
	exact: true,
};
